import { MuiThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { Home } from './components/Home';
import { configureStore } from './redux/configureStore';
import { theme } from './styles/theme';
import AccountLogin from './components/AccountLogin';
import authService from './authService';
import addPassword from './components/AddPassword';
import addPasswordTesti from './components/AddPasswordTesti';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                    <Route exact path="/Account/Login" render={AccountLogin} />
                    <Route
                        path="/"
                        render={() => {
                            if (window.location.href.includes('/AddPassword')) {
                                return <></>;
                            }
//                            if (window.location.href.includes('/AddPasswordTesti')) {
//                                return <></>;
//                            }
                            if (window.location.href.endsWith('/Account/Login')) {
                                return <></>;
                            }
                            if (authService.isTokenOk()) {
                                return <></>;
                            }
                            authService.logout();
                            window.location.href = '/Account/Login';
                            return <></>;
                        }}
                    />
                    <Route
                        exact
                        path="/"
                        render={() => {
                            window.location.href = '/Preview';
                            return <></>;
                        }}
                    ></Route>
                    <Route exact path="/AddPassword" render={addPassword}></Route>
                    <Route exact path="/AddPasswordTesti" render={addPasswordTesti}></Route>
                    <Route path="/(Preview|Search)" render={Home} />
                </MuiThemeProvider>
            </Provider>
        );
    }
}
